<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="testibreak"><span class="testibreak1">“Ann Hazelwood displays such a wonderful tribute to small towns. She brings it out in her experience and love for Missouri history. I am very anxious to read her next series since I am from Perry County. I know she’ll put a creative spin on her characters. I love her descriptive words and imagination.”</span><span class="testibreak1"></span></p>
<p class="testimonial-name"><span class="testimonial-name1">— </span><span class="testimonial-name1">Joan Brown,</span></p>
<p class="testimonial-name"><span class="testimonial-name1">St. Mary, Missouri</span><span class="testimonial-body"></span></p>
<p class="testimonial-name"><span class="testimonial-body"> </span></p>
<p class="trstimonial-body"><span class="testimonial-body">“East Perry County is the perfect fictional setting for Ann’s new series. There is no place with more authentic German-American culture, beautiful landscapes, and memorable characters. I cannot wait to begin her journey.”</span></p>
<p class="testimonial-name"><span class="testimonial-name1">—</span><span class="testimonial-name1">Carla Jordan,</span></p>
<p class="testimonial-name"><span class="testimonial-name1">Director of Lutheran Heritage Center and Cape County History Center<a id="x.276"></a></span></p>
<p class="testimonial-name"><span class="testimonial-name1">Cape Girardeau, Missouri</span><span class="testimonial-body"></span></p>
<p class="testimonial-name"><span class="testimonial-body"> </span></p>
<p class="trstimonial-body"><span class="testimonial-body">“My excitement, besides the location, is that the next series will unveil the treasure of tradition this part of the country has to offer. The beauty of Missouri and its people should be shared!”</span><span class="testimonial-body"></span></p>
<p class="testimonial-name"><span class="testimonial-name1">—Pat Rappa</span></p>
<p class="testimonial-name"><span class="testimonial-name1">Franklin, Tennessee</span><span class="testimonial-body"></span></p>
<p class="testimonial-name"><span class="testimonial-body"> </span></p>
<p class="trstimonial-body"><span class="testimonial-body">“I have really enjoyed reading Ann Hazelwood’s Colebridge Series. I found it uplifting and charming. I’m looking forward to reading more of her work.”</span></p>
<p class="testimonial-name"><span class="testimonial-name1">— </span><span class="testimonial-name1">Jacalyn Ryberg</span></p>
<p class="testimonial-name"><span class="testimonial-name1">Las Cruces, New Mexico</span><span class="testimonial-body"></span></p>
<p class="testimonial-name"><span class="testimonial-body"> </span><span class="testimonial-body"></span></p>
<p class="trstimonial-body"><span class="testimonial-body">“As a quilt shop owner, I find it fun and lucrative to carry Ann Hazelwood’s books. I really look forward to her next series!”</span></p>
<p class="testimonial-name"><span class="testimonial-name1">— </span><span class="testimonial-name1">Christy Starr</span></p>
<p class="testimonial-name"><span class="testimonial-name1">Owner of The Quilted Cottage St. Charles, Missouri</span></p>
<p class="testimonial-name"><span class="testimonial-name1"> </span></p>
<div class="frame">
<img alt="85580.png" class="frame1" src="OEBPS/image/85580.png"/>
</div>
<p class="testimonial-name"><span class="testimonial-name1"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// forgiv_ebook3.vue?3058e16d